export const COURSE_ICON_PALETTE_VERSION = 1;

export const COURSE_ICON_COLOR_CLASSES = [
  "bright-red-text",
  "blue-text",
  "bright-yellow-text",
  "pastel-dark-purple-text",
  "bright-green-text",
  "dark-brown-text",
  "turquoise-text",
  "orange-text",
  "pastel-light-blue-text",
  "green-text",
  "dark_blue-text",
  "dark-blue-grey-text",
  "purple-text",
  "pastel-light-green-text",
  "pastel-brown-text",
  "bright-blue-text",
  "pastel-light-yellow-text",
  "pastel-turquoise-text",
  "red-text",
  "pastel-light-purple-text",
  "yellow-text",
  "pastel-light-turquoise-text",
  "dark-purple-text",
  "pastel-light-orange-text",
  "pastel-blue-text",
  "gray-text",
];

export const buildCourseIconLookup = (response = {}) => {
  if (
    parseInt(response?.palette_version, 10) !==
    COURSE_ICON_PALETTE_VERSION
  ) {
    return {};
  }

  return (Array.isArray(response?.icons) ? response.icons : []).reduce(
    (results, icon) => {
      if (icon?.course_id === undefined || icon?.course_id === null) {
        return results;
      }

      const iconSlot = parseInt(icon.icon_slot, 10);
      if (!Number.isInteger(iconSlot) || iconSlot < 0) {
        return results;
      }

      const colorSlot = parseInt(icon.color_slot, 10);
      const normalizedColorSlot = Number.isInteger(colorSlot)
        ? ((colorSlot % COURSE_ICON_COLOR_CLASSES.length) +
            COURSE_ICON_COLOR_CLASSES.length) %
          COURSE_ICON_COLOR_CLASSES.length
        : 0;
      results[`${icon.course_id}`] = {
        course_id: icon.course_id,
        icon_slot: iconSlot,
        color_slot: normalizedColorSlot,
        color: COURSE_ICON_COLOR_CLASSES[normalizedColorSlot],
        palette_version: parseInt(icon.palette_version, 10),
      };
      return results;
    },
    {}
  );
};

export const getCourseIcon = (
  courseIconsByCourseID = {},
  courseID,
  fallback = {}
) => {
  const persistentIcon =
    courseID === undefined || courseID === null
      ? null
      : courseIconsByCourseID[`${courseID}`];

  return {
    icon_slot: persistentIcon?.icon_slot ?? null,
    color: persistentIcon?.color || fallback.color || null,
    legacy_icon_key: fallback.request_icon || null,
  };
};
